import React from 'react';
import { lazyWithRetry } from '../../utils/lazyWithRetry';
import { AppRoute } from '../routes.types';
import ComingSoon from '../../components/ComingSoon/ComingSoon';
import SubscriptionsPage from '../../containers/SubscriptionsPage/SubscriptionsPage';

const VenueHome = lazyWithRetry(() => import('../../venues/pages/VenueHome/VenueHome').then(m => ({ default: m.VenueHome })));

export const LEGACY_FLAT_ROUTES: AppRoute[] = [
    { path: '/demos', element: <ComingSoon />, withAppShell: true },
    { path: '/referrals', element: <ComingSoon />, withAppShell: true },
    { path: '/w-9-Update-Approval', element: <ComingSoon />, withAppShell: true },
    { path: '/payment-request-status', element: <ComingSoon />, withAppShell: true },
    { path: '/new-charity-approval', element: <ComingSoon />, withAppShell: true },
    { path: '/my-resources', element: <ComingSoon />, withAppShell: true },
    { path: '/members', element: <ComingSoon />, withAppShell: true },
    { path: '/discount-code', element: <ComingSoon />, withAppShell: true },
    { path: '/annual-discount', element: <ComingSoon />, withAppShell: true },
    { path: '/volume-discount', element: <ComingSoon />, withAppShell: true },
    { path: '/member-services-management', element: <ComingSoon />, withAppShell: true },
    { path: '/subscriptions', element: <SubscriptionsPage />, withAppShell: true },
    { path: '/venues-home', element: <VenueHome />, withAppShell: true },
];
